import {NavigationContainerRef} from '@react-navigation/core';
import {appScreen} from 'constant/appScreen';
import * as React from 'react';

export const navigationRef = React.createRef<
  NavigationContainerRef<any> | undefined
>();
const timeoutref: any = React.createRef();

export function navigate(
  name: appScreen,
  params?: object,
  cancelDebounce?: boolean,
) {
  return new Promise<void>(resolve => {
    if (__DEV__) {
      console.log('SCREEN:', name);
    }
    navigationRef.current?.navigate(name as string, params);
    resolve();
  });
}

export function goBack() {
  return new Promise((rs, rj) => {
    if (navigationRef.current && navigationRef.current.canGoBack()) {
      navigationRef.current?.goBack();
    }
    rs('');
    return '';
  });
}
